// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__TuvVF","info":"PatientInfo_info__7P63d"};